var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDj20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15,1.5c7.44,0,13.5,6.06,13.5,13.5s-6.06,13.5-13.5,13.5S1.5,22.44,1.5,15,7.56,1.5,15,1.5M15,0C6.72,0,0,6.72,0,15s6.72,15,15,15,15-6.72,15-15S23.28,0,15,0h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.99,17.19c.24-.39,2.8-1.84,2.8-1.84l-2.36.43c-.35-.02-.51-.31-.71-.84.02-.13.03-.26.03-.39,0-2.17-3.08-3.92-6.87-3.92-3.39,0-6.19,1.4-6.76,3.24h0s-.09.26-.19.74c-.26-.72-.97-1.42-2.03-1.92-2.12-1-3.99-.87-4.67.57.87,1.91,3.5,2.67,5.22,3.5.76.37,1.06.51,1.17.5-.01.26-.02.54-.02.84-.6,0-.76.84-.76,1.28h2.42c.05-.48.22-1.12.6-1.54.89.48,2.67.81,4.74.81s4.02-.36,4.87-.87c.43.24.9.69.95,1.6h2.69c-.14-.87-.46-2.05-1.11-2.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj20);
export default __webpack_public_path__ + "static/media/DJ20.33ba06fb22b95fcc99fb5e45348c399a.svg";
export { ForwardRef as ReactComponent };